import { Button, ButtonSize, ButtonVariant, EventNames } from '@farmasiet/frontendcore-reactcomponents';
import * as React from 'react';
import { useEffect, useState } from 'react';

import { getTranslation, keys } from '../../../../../Resources/Translations';
import { Modal, ModalButtons, ModalButtonsDirection, ModalHeading, ModalText } from '../../../../ReactComponents/Modal/Modal';

export const onActionRequiresLogin = (productCode: string, scrollPosition: number) => {
    const event = new CustomEvent(EventNames.ActionRequiresLogin, {
        detail: { productCode, scrollPosition }
    });
    window.dispatchEvent(event);
};

export interface FavouritesClickData {
    productCode: string;
    scrollPosition: number;
}

export interface FavouritesLoginModalProps {
    readonly loginUrl: string;
    readonly registerUrl: string;
}

export const favouritesRequestRedirectParams = {
    productCode: 'addFavouriteProduct',
    scrollPosition: 'scrollPosition'
};

export const RequiresLoginModal = ({ loginUrl, registerUrl }: FavouritesLoginModalProps) => {
    const [isVisible, setIsVisible] = useState(false);
    const [productCode, setProductCode] = useState('');
    const [scrollPosition, setScrollPosition] = useState(0);
    const ampersand = '%26';

    useEffect(() => {
        window.addEventListener(EventNames.ActionRequiresLogin, showModal);

        return () => {
            window.removeEventListener(EventNames.ActionRequiresLogin, showModal);
        };
    });

    const showModal = ($event: CustomEventInit) => {
        if ($event && $event.detail) {
            const data = $event.detail as FavouritesClickData;

            if (data?.productCode) {
                setProductCode(data.productCode);
                setScrollPosition(data.scrollPosition);
                setIsVisible(true);
                return;
            }
        }

        setProductCode('');
        setScrollPosition(0);
    };

    const getLoginUrl = (): string => {
        const params = getEncodedUrlParams();
        return (
            loginUrl +
            `?` +
            (params ? `${params}${ampersand}` : '') +
            (productCode ? `${favouritesRequestRedirectParams.productCode}=${productCode}${ampersand}` : '') +
            (scrollPosition ? `${favouritesRequestRedirectParams.scrollPosition}=${scrollPosition}` : '')
        );
    };

    const getEncodedUrlParams = (): string => {
        let params = new URLSearchParams(window.location.search).toString();
        params = params.replace(/&/g, ampersand);
        return params;
    };

    const redirectToRegister = () => {
        window.location.href = registerUrl;
    };

    const redirectToLogin = () => {
        window.location.href = getLoginUrl();
    };

    return (
        <Modal open={isVisible} onClose={() => setIsVisible(false)} className="LoginFavouritesModal">
            <ModalHeading>{getTranslation(keys['favourites.loginRequiredHeader'])}</ModalHeading>
            <ModalText>{getTranslation(keys['favourites.loginRequiredContent'])}</ModalText>
            <ModalButtons direction={ModalButtonsDirection.Column}>
                <Button size={ButtonSize.Medium} variant={ButtonVariant.Link} onClick={redirectToRegister}>
                    {getTranslation(keys['favourites.register'])}
                </Button>
                <Button size={ButtonSize.Medium} variant={ButtonVariant.Primary} onClick={redirectToLogin}>
                    {getTranslation(keys['favourites.login'])}
                </Button>
            </ModalButtons>
        </Modal>
    );
};
